/**
 * @flow
 * @relayHash 179dc6d123903b6235094aa895d1e197
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PrePostMutationInput = {|
  formName: string,
  responses: $ReadOnlyArray<?Response>,
  clientMutationId?: ?string,
|};
export type Response = {|
  question: string,
  answer: string,
|};
export type CopenhagenPsychosocialPt2MutationVariables = {|
  input: PrePostMutationInput
|};
export type CopenhagenPsychosocialPt2MutationResponse = {|
  +prepostMutation: ?{|
    +nextForm: ?string
  |}
|};
export type CopenhagenPsychosocialPt2Mutation = {|
  variables: CopenhagenPsychosocialPt2MutationVariables,
  response: CopenhagenPsychosocialPt2MutationResponse,
|};
*/


/*
mutation CopenhagenPsychosocialPt2Mutation(
  $input: PrePostMutationInput!
) {
  prepostMutation(input: $input) {
    nextForm
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "PrePostMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "prepostMutation",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PrePostMutationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "nextForm",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CopenhagenPsychosocialPt2Mutation",
    "type": "RelayMutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CopenhagenPsychosocialPt2Mutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CopenhagenPsychosocialPt2Mutation",
    "id": null,
    "text": "mutation CopenhagenPsychosocialPt2Mutation(\n  $input: PrePostMutationInput!\n) {\n  prepostMutation(input: $input) {\n    nextForm\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3f14daf680c169d6dde33a0a19c38d2c';
module.exports = node;
